/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const RoxPermissonBooking = {
  permission_booking_enable: new Rox.Flag(false),
  permission_booking_enable_v2: new Rox.Flag(false),
  permission_booking_create_manual: new Rox.Flag(false),
  permission_booking_create_for_corporate: new Rox.Flag(false),
  permission_booking_create_shipment_id: new Rox.Flag(false),
  permission_booking_create_shipment_id_v2: new Rox.Flag(false),
  permission_instant_booking_create: new Rox.Flag(false),
  permission_instant_booking_detail: new Rox.Flag(false),
  permission_advance_filter_client_partner_click: new Rox.Flag(false),
  permission_booking_view_list: new Rox.Flag(false),
  permission_booking_view_list_v2: new Rox.Flag(false),
  permission_booking_view_detail: new Rox.Flag(false),
  permission_pieces_booking_shipment: new Rox.RoxString(""),
  tokopedia_gap_weight_validation_prefix: new Rox.RoxString(""),
  hws_configuration: new Rox.Flag(false),
  permission_booking_version: new Rox.RoxString(""),
  config_whitelist_id_client_branch_add_pieces: new Rox.RoxString("24030"),
  adjust_recipient_prefix_stt: new Rox.RoxString("10,11"),
  config_show_bigpack_fast: new Rox.Flag(false)
};

const FcsPermissionBooking = {
  config_is_new_endpont_detail_stt: new FcsFlag.Flag(true),
  permission_booking_edit: new FcsFlag.Flag(false),
  disable_cod_dfod_for_limited_number: new FcsFlag.Flag(false),
  permission_shipment_booking_mp: new FcsFlag.StringFlag(""),
  flag_booking_print_invoice_receipt_enabled: new FcsFlag.Flag(true),
  permission_generate_client_data_from_shipment_id: new FcsFlag.Flag(true),
  permission_booking_v4_create_manual: new FcsFlag.Flag(true),
  permission_booking_v4_create_client: new FcsFlag.Flag(true),
  permission_booking_v4_edit: new FcsFlag.Flag(true),
  permission_booking_v4_reverse_journey: new FcsFlag.Flag(true)
};

const BcsPermissionBooking = {
  config_filter_product_list: new BcsFlag.StringFlag("")
}

export const FlagsPermissionBooking = {
  ...RoxPermissonBooking,
  ...FcsPermissionBooking,
  ...BcsPermissionBooking
};

export function initFlagsPermissionBooking() {
  // register flags with namespaces for better grouping
  Rox.register("featureBooking", RoxPermissonBooking);
  BcsFlag.register("featureBooking", BcsPermissionBooking);
  FcsFlag.register("featureBooking", FcsPermissionBooking);
}
